/**
 * A path segment that must name a record.
 *
 * Both detail screens read a numeric id out of the URL and hand it to a fetch.
 * `Number("oops")` is `NaN`, which the hooks refuse to request — leaving the
 * coach on a skeleton that never resolves — and which reached
 * `NewDiagnosticDialog` as a locked `NaN` company. Anything that is not a
 * positive whole number is rejected here instead, so the screen can render a
 * not-found state.
 */
export const parseRecordId = (raw: string | undefined): number | null => {
  if (raw === undefined || !/^\d+$/.test(raw)) return null;
  const id = Number(raw);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};
